const about = `
Chez Dealygo, nous croyons que se faire plaisir ne
devrait pas coûter une fortune. Notre mission est simple : vous offrir les meilleures offres et
réductions pour vos sorties, vos moments bien-être, vos loisirs et même des services essentiels
comme l’entretien de votre véhicule ou vos courses gourmandes.
Nous avons créé Dealygo pour rendre la vie plus accessible et agréable, en vous aidant à
économiser tout en découvrant de nouvelles expériences. Que ce soit pour un dîner au
restaurant, une séance de spa, un contrôle technique ou un bon morceau de viande, nous
sélectionnons des partenaires de confiance pour vous garantir des bons plans de qualité.
Pourquoi payer plus cher quand vous pouvez payer malin ? Avec Dealygo, profitez
plus, dépensez moins, et faites de chaque instant un moment unique… sans exploser
votre budget.
`;

export default about;
